__turbopack_context__.v({
  "cardsContainer": "serviceCards-module-scss-module__Zk9UVa__cardsContainer",
  "serviceCards": "serviceCards-module-scss-module__Zk9UVa__serviceCards",
  "text": "serviceCards-module-scss-module__Zk9UVa__text",
  "title": "serviceCards-module-scss-module__Zk9UVa__title",
});
